import React from 'react';
import AircraftCard from './AircraftCard';

function AircraftGrid({ aircraft }) {
  if (aircraft.length === 0) {
    return (
      <div className="empty-state">
        <p>No aircraft found matching your filters.</p>
      </div>
    );
  }

  return (
    <div className="aircraft-grid">
      {aircraft.map((plane) => (
        <AircraftCard key={plane.id} aircraft={plane} />
      ))}
    </div>
  );
}

export default AircraftGrid;
